module.exports = 'hmTouchEvents';

var angular = require('angular');
Hammer = require('hammerjs');
require('./angular.hammer')



//////////////////
// WEBPACK FOOTER
// ./~/angular-hammer/index.js
// module id = 362
// module chunks = 2